module.exports = __webpack_public_path__ + "static/09-d9f2cf08d50f8589f1ba8375e108fb98.jpg";